import React, { useState } from "react";
import { Container } from "react-bootstrap";
import MainDashboard from "./MainDashboard/MainDashboard";
import AddNews from './AddNew/AddNews';
import Sidebar from './sidebar/Sidebar';
import Header from './header/header';
import TouristInfoCenter from "./Tourist information Center/TouristInformationCenter";
import './Dashboard.css';
import Comments from "./Comments/Comments";
import TouristAttraction from './Tourist atraction/Atraction';
import AgenesisApproval from "./Agenesis/AgenesisApproval";
import AddEvent from './AddEvent/AddEvent';

const Dashboard = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [activeComponent, setActiveComponent] = useState("MainDashboard"); // Default component

  const toggleSidebar = () => {
    console.log("Toggling sidebar", isSidebarVisible);
    setIsSidebarVisible(prevState => !prevState);
  };

  const renderComponent = () => {
    switch (activeComponent) {
      case "MainDashboard":
        return <MainDashboard />;
      case "AddNews":
        return <AddNews />;
      case "AddEvents":
        return <AddEvent />;
      case "Comments":
        return <Comments />;
      case "TouristAttraction":
        return <TouristAttraction />;
      case "TouristInfoCenter":
        return <TouristInfoCenter />;
      case "AgenesisApproval":
        return <AgenesisApproval />;
      case "Contact":
        return <div>Contact Component</div>; // Placeholder for Contact component
      default:
        return <AddNews />;
    }
  };

  return (
    <div className="main-dashboard">
      <Sidebar 
        className={`side ${isSidebarVisible ? '' : 'hidden'}`} 
        onSelectComponent={(component) => {
          setActiveComponent(component);
        }} // Pass the function to Sidebar
        activeComponent={activeComponent} // Pass the active component for styling
      />
      <div className={`maindash ${isSidebarVisible ? 'with-sidebar' : 'full-width'}`}>
        <Header toggleSidebar={toggleSidebar} />
        <Container fluid className="content">
          {renderComponent()} {/* Render the selected component */}
        </Container>
      </div>
    </div>
  );
};

export default Dashboard;